import PlaceSettingIcon from './PlaceSettingIcon'

export default PlaceSettingIcon
